import React from 'react'

import {
  Box,
  Button,
  CollapsableCard,
  Colors,
  Icon,
  LargeIcon,
  Text,
  useToggle,
} from '@factorialco/deprecated-design-system'

export interface LeftIconProps {
  icon: LargeIcon
  color: Colors
  background: Colors
}
export interface Props {
  title: string
  subtitle?: string
  cta: string
  open?: boolean
  disabled?: boolean
  completed?: boolean
  leftIcon: LeftIconProps
}
export const CollapsableIconCard = ({
  title,
  subtitle,
  open = false,
  cta,
  disabled,
  completed,
  leftIcon,
  children,
}: React.PropsWithChildren<Props>) => {
  const [isOpen, toggle] = useToggle(open)

  return (
    <CollapsableCard
      open={disabled ? false : isOpen}
      Card={
        <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
          <Box
            flexDirection="row"
            gap="s8"
            alignItems="center"
            width="full"
            onClick={disabled ? undefined : toggle(!isOpen)}
          >
            <Box padding="s6" background={leftIcon.background} borderRadius={{ all: 'abs008' }}>
              <Icon.Large icon={leftIcon.icon} color={leftIcon.color} />
            </Box>
            <Text.Normal color="textPrimary" weight="semibold">
              {title}
            </Text.Normal>
            <Text.Normal size="200" ellipsis color="textPrimary">
              {subtitle && ` - ${subtitle}`}
            </Text.Normal>
          </Box>
          <RightAnchor completed={completed} cta={cta} disabled={disabled} toggle={toggle} />
        </Box>
      }
      Content={children}
    />
  )
}

interface RightAnchorProps {
  completed?: boolean
  cta: string
  disabled?: boolean
  toggle: (open: boolean) => () => void
}

const RightAnchor = ({ completed, cta, disabled, toggle }: RightAnchorProps) => {
  if (completed)
    return (
      <Box
        padding="s6"
        border={{ all: { color: 'lime1000', style: 'solid', width: 's2' } }}
        borderRadius={{ all: 'rel1000' }}
      >
        <Icon.Medium icon="check" color="lime1000" />
      </Box>
    )

  return (
    <Button type="secondary" disabled={disabled} onClick={toggle(true)}>
      {cta}
    </Button>
  )
}
